import React from 'react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-32" data-mp="gwx5x4ldv9es">
      <Reveal className="mx-auto max-w-3xl" data-id="element-33" data-mp="vsmkwis5ima0">
        <div className="mb-10 text-center" data-id="element-34" data-mp="vtnwcod2xas9">
          <p className="mb-4 font-note text-[10px] font-semibold tracking-[0.24em] text-sage sm:text-xs" data-id="element-35" data-mp="qtt5gktb0l77">
            INCLUSI NEL PACCHETTO
          </p>
          <h2 className="text-3xl font-bold tracking-tight text-petrol md:text-4xl" data-id="element-36" data-mp="14s9kr058fk0y">5 Bonus Esclusivi</h2>
          <p className="mt-4 text-sm text-muted md:text-base" data-id="element-37" data-mp="ztycuuyhzjld">
            Un valore di <span className="font-semibold text-petrol" data-id="element-38" data-mp="1eiccyy4j4ty8">100 €</span>, compreso nel prezzo senza costi
            aggiuntivi.
          </p>
        </div>
        <div className="space-y-3" data-id="element-39" data-mp="19mnc8rgrx70c">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-xl border border-line bg-sand p-5 shadow-soft sm:gap-6" data-id="element-40" data-mp="1nkbzg5ybcq8k" data-mpi={index}>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-petrol font-heading text-sm font-semibold text-white" data-id="element-41" data-mp="3prwkytjga1va">
                {index + 1}
              </span>
              <div className="min-w-0 flex-1" data-id="element-42" data-mp="2k1afb9qcrm4">
                <h3 className="font-heading text-base font-semibold leading-snug text-petrol" data-id="element-43" data-mp="7kfk0xqzc9m9">{bonus.title}</h3>
                <p className="mt-1 font-note text-xs leading-relaxed text-muted" data-id="element-44" data-mp="ckboey3la32c">{bonus.description}</p>
              </div>
              <div className="shrink-0 text-right" data-id="element-45" data-mp="gk2ltknmfhfu">
                <span className="block font-note text-[9px] font-semibold tracking-[0.12em] text-muted" data-id="element-46" data-mp="lc3s8py3ydxy">VALORE</span>
                <span className="font-heading text-sm font-semibold text-sage" data-id="element-47" data-mp="qbq7t61es69x">{bonus.price}</span>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}